import { render, staticRenderFns } from "./ConfirmCart.vue?vue&type=template&id=1c28e12e&scoped=true&"
import script from "./ConfirmCart.vue?vue&type=script&lang=ts&"
export * from "./ConfirmCart.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmCart.vue?vue&type=style&index=0&id=1c28e12e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c28e12e",
  null
  
)

export default component.exports